import { convexClient } from "@convex-dev/better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
  baseURL:
    typeof window !== "undefined"
      ? window.location.origin
      : process.env.NEXT_PUBLIC_SITE_URL,
  plugins: [convexClient()],
  // No session refetch on tab focus: for visitors without a session the
  // refetch flips `useSession().isPending` → `useConvexAuth().isLoading`,
  // which unmounted live meeting rooms on every tab switch. Sign-in/out
  // still syncs across tabs via the broadcast channel.
  sessionOptions: { refetchOnWindowFocus: false },
});
